import { createNavigation } from 'next-intl/navigation';

import { routing } from './routing';

// Locale-aware navigation helpers. Use this `Link`/`useRouter` for
// locale-prefixed application links so the active locale is preserved.
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
